import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const AdminFooterLink = () => {
  const { user } = useAuth();
  if (!user || user.role !== "admin") return null;
  return (
    <Link to="/admin" data-testid="footer-admin-link" className="inline-flex items-center gap-1.5 transition-colors hover:text-terra">
      <Crown size={11} /> Espace fondatrice
    </Link>
  );
};
